/**
 * Redirect Url
 */
const redirectUrl = 'https://iqos.com.ua/?utm_source=iqos_questionary';

export { redirectUrl };
